import React from 'react'
import "./guarantee.css"

const Guarantee = () => {
  return (
    <div>
        <section class="about-us">
    <div class="container">
      <h2 className='heading-style'>Our Promise</h2>
      <p>At Lonestar Stain and Seal, we stand behind our work with a steadfast guarantee of 
              satisfaction. We are committed to delivering exceptional results that exceed your 
              expectations, and if for any reason you are not completely satisfied with our fence 
              staining services, we will work tirelessly to make it right. Your satisfaction is our 
              top priority, and we strive to ensure that every aspect of our work meets the highest 
              standards of quality and professionalism. With Lonestar Stain and Seal, you can trust that 
              your fence staining project is in capable hands, and we guarantee your complete 
              satisfaction every step of the way.</p>
      {/* <img  src={ aboutimg } alt="Company Team"/> */}
    </div>
    </section>
    </div>
  )
}

export default Guarantee
